export default __webpack_public_path__ + "static/media/SONGS LIST (dark).3b79e164.png";